import { currentActiveFileUpdated } from 'features/content-library/contentLibrarySlice';
import {
  ContentLibraryOpenedFileEntry,
  ContentLibraryOpenedWhiteboard,
} from 'features/content-library/types';
import { fileViewed, whiteboardViewed } from 'features/content-library/actions';
import { gridPanelInitialized } from 'features/layout/features/content/contentSlice';
import { GridPanelName } from 'features/layout/features/content/types';
import { loaderDisplayChanged } from 'features/whiteboard/whiteboardSlice';
import { call, put } from 'redux-saga/effects';
import { board } from 'utils/whiteboard/BoardStateManager';

export function* initializeGridPanelSaga(
  activeTab: GridPanelName,
  openedFile: ContentLibraryOpenedFileEntry | null,
  openedWhiteboard: ContentLibraryOpenedWhiteboard | null,
  availableTabs: Record<GridPanelName, boolean>
): Generator<unknown, void, never> {
  yield put(
    gridPanelInitialized({
      activeTab,
      availableTabs,
    })
  );

  if (activeTab === 'contentLibrary' && openedFile) {
    yield put(
      fileViewed({
        id: openedFile.id,
        data: {
          page: openedFile.page,
          url: openedFile.url,
        },
      })
    );

    yield put(currentActiveFileUpdated(openedFile.id));
  }

  if (activeTab === 'whiteboard' && openedWhiteboard) {
    yield call(board.reset);
    yield put(loaderDisplayChanged(true));
    yield put(whiteboardViewed(openedWhiteboard.id));
  }
}
